import gql from 'graphql-tag';

const GET_KEYNOTES = gql`
  query keynotes {
    keynotes {
      items {
        id
        image
        name
        job
        company
        logo
      }
    }
  }
`
;

export default GET_KEYNOTES;



/** WEBPACK FOOTER **
 ** ./src/graphql/GET_KEYNOTES.js
 **/